var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_18890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0488 3.36719H4.29083L4.24883 3.01619C4.16288 2.28661 3.81221 1.61392 3.26332 1.12567C2.71442 0.637411 2.00546 0.367529 1.27083 0.367188L0.0488281 0.367188V2.36719H1.27083C1.51576 2.36722 1.75217 2.45714 1.9352 2.6199C2.11824 2.78266 2.23517 3.00694 2.26383 3.25019L3.84883 16.7182C3.93478 17.4478 4.28544 18.1205 4.83434 18.6087C5.38323 19.097 6.0922 19.3668 6.82683 19.3672H20.0488V17.3672H6.82683C6.58174 17.3671 6.34521 17.2771 6.16215 17.1141C5.9791 16.9511 5.86226 16.7266 5.83383 16.4832L5.70283 15.3672H21.8848L24.0488 3.36719ZM20.2128 13.3672H5.46783L4.52683 5.36719H21.6558L20.2128 13.3672Z",
    fill: "#253D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04883 24.3672C8.1534 24.3672 9.04883 23.4718 9.04883 22.3672C9.04883 21.2626 8.1534 20.3672 7.04883 20.3672C5.94426 20.3672 5.04883 21.2626 5.04883 22.3672C5.04883 23.4718 5.94426 24.3672 7.04883 24.3672Z",
    fill: "#253D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0488 24.3672C18.1534 24.3672 19.0488 23.4718 19.0488 22.3672C19.0488 21.2626 18.1534 20.3672 17.0488 20.3672C15.9443 20.3672 15.0488 21.2626 15.0488 22.3672C15.0488 23.4718 15.9443 24.3672 17.0488 24.3672Z",
    fill: "#253D4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_18890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0488281 0.367188)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.e7b8ad89304fa0e785ce1419946a7608.svg";
export { ForwardRef as ReactComponent };